import { useState } from "react";
import { Link, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get("next") || location.state?.from || "/";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) { setError(res.error); return; }
    toast.success(`Welcome back, ${res.user.name}!`);
    if (res.user.role === "admin") navigate("/admin");
    else navigate(redirectTo);
  };

  return (
    <div data-testid="login-page" className="max-w-md mx-auto px-6 py-16 sm:py-24">
      <div className="font-script text-3xl text-[#2eb6a8]">Welcome Back</div>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-[#1c1815] tracking-tight">Log In</h1>

      <form onSubmit={submit} className="mt-8 space-y-4 p-7 sm:p-8 rounded-3xl border border-[#e5dccd] bg-white shadow-sm">
        <div>
          <label className="text-[10px] uppercase tracking-[0.25em] text-[#8a8076] font-bold">Email</label>
          <input type="email" required data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)}
            className="mt-1.5 w-full bg-[#faf4e9] border border-[#e5dccd] focus:border-[#2eb6a8] focus:ring-2 focus:ring-[#2eb6a8]/20 rounded-xl px-4 py-3 outline-none text-[#1c1815]"/>
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-[0.25em] text-[#8a8076] font-bold">Password</label>
          <input type="password" required data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)}
            className="mt-1.5 w-full bg-[#faf4e9] border border-[#e5dccd] focus:border-[#2eb6a8] focus:ring-2 focus:ring-[#2eb6a8]/20 rounded-xl px-4 py-3 outline-none text-[#1c1815]"/>
        </div>
        {error && <div data-testid="login-error" className="text-[#c93875] text-sm">{error}</div>}
        <button type="submit" disabled={loading} data-testid="login-submit"
          className="w-full bg-[#2eb6a8] hover:bg-[#1f8d83] hover:shadow-lg hover:-translate-y-0.5 text-white font-bold uppercase tracking-[0.2em] text-xs py-3.5 rounded-full transition-all disabled:opacity-60">
          {loading ? "Logging in…" : "Log In"}
        </button>
        <p className="text-center text-sm text-[#8a8076]">
          New here? <Link to="/register" className="text-[#e8478e] font-bold hover:text-[#c93875]">Create an account</Link>
        </p>
      </form>
    </div>
  );
}
